import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./videomeetchat.module.scss";
import _ from "lodash";
import { ParticipantDetails, initialStateModel } from "../../../base/models/meetModal";
import store from '../../../store/redux-store/root_store';
import { useSelector } from "react-redux";
import VideoSmall from "../../webChatScreen/videoWidgets/videoSmall";
import Videofooter from "../../webChatScreen/videoWidgets/videofooter";
import { URemojiMessage } from "../../../shared/widges/emoji";
import { excelMimeFormats, fileupload, imageFormatType, iterateSoreChat, mp3Formats, pdfFormats, pptMimeFormats, wordMimeFormats, zipMimeFormats } from "../../../base/video_common";
import { meetActionTypes } from "../../../base/action/action";
import iconpdf from "../../../styles/images/filepdf.svg"
import iconmusic from "../../../styles/images/grid_music.svg";
import iconxls from '../../../styles/images/grid_xls.svg';
import iconword from '../../../styles/images/fileword.svg';
import iconppt from '../../../styles/images/grid_ppt.svg';
import iconzip from '../../../styles/images/grid_zip.svg';
import { getToken } from "../../../base/utils";
import { updateToParticipants, videoCallService } from "../../../base/service/videoCallService";
import { notification } from "antd";
type FooterRightState = {
  isParticipantSide: boolean;
  isEmoji: boolean;
  participant: Array<ParticipantDetails>;
  tempfilteredParticipant: Array<ParticipantDetails>;
  messageText: string;
  toParticipants: any;
}

export default function VideoMeetingChat() {

  const [meetInfo, setMeetInfo] = useState<FooterRightState>
    ({
      isParticipantSide: false, isEmoji: false,
      participant: [], tempfilteredParticipant: [], messageText: "", toParticipants: { name: "Everyone Publicaly and Privately" }
    });

  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const { meetingDetails } = videoMeetState.meetingReducer;
  const { toParticipant, message } = videoMeetState.messageReducer;
  const sendMessage = (event: any) => {
    event.preventDefault();
    let { messageText } = meetInfo;
    if (meetInfo.messageText.trim() !== "") {
      videoCallService.sendPrivateChat(toParticipant.conId, messageText);

      setMeetInfo({ ...meetInfo, messageText: "", isEmoji: false });
    }
  };

  const { activeParticipantList, currdeviceinfo } = store.getState().meetingReducer;





  useEffect(() => {
    let filtered_list = _.orderBy(activeParticipantList, [(elem: ParticipantDetails) => elem.name.toUpperCase()], ['asc']);
    let filtered_array = _.filter(filtered_list, function (o) { return (o.conId !== currdeviceinfo.conId && !o.conId.includes('_screenshare')) });
    const filter_part = filtered_array.length === 0 ? "" : filtered_array[0];
    let part: any = filter_part;
    updateToParticipants(part);
    videoCallService.getChats(part.conId, "private");
    iterateSoreChat(part);
  },[activeParticipantList]);


  const emojiClick = () => {
    let { isEmoji } = meetInfo;
    setMeetInfo({ ...meetInfo, isEmoji: !isEmoji });
  };

  const onUpdateMessage = (name: string, event: any) => {
    if (name) {
      setMeetInfo({ ...meetInfo, [name]: event.currentTarget.value });
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && meetInfo.messageText.trim() !== "") {
      sendMessage(e);
    } else return;
  };

  const onEmojiClick = (emojiObject: any) => {
    setChosenEmoji(emojiObject);
  };


  const setChosenEmoji = (data: any) => {
    let { messageText } = meetInfo;
    setMeetInfo({ ...meetInfo, messageText: messageText.concat(data) });
  };

  const inputFileClick = () => {
    const fileAttachInput = document.getElementById('attachInput');
    fileAttachInput?.click();
  };

  const uploadFile = (event: any) => {
    const files = event.target.files[0];
    let { uuid } = meetingDetails;
    let remotedev: any = activeParticipantList.filter((ele: any) => { return ele.conId !== currdeviceinfo.conId })
    const filteredhost: any = _.find(activeParticipantList, { conId: remotedev[0] ? remotedev[0]?.conId : remotedev?.conId });
    fileupload(files, uuid, toParticipant.conId, "private");

  };

  const gotoBottom = (id: string) => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.scrollTop = element?.scrollHeight - element?.clientHeight;
    }
  };

  const chatWindow = () => {
    let getCookie: any = getToken();
    if (getCookie["ssoToken"]) {
      store.dispatch({
        type: meetActionTypes.MEETING_CONTROL_OPEN,
        payload: {
          componentState: "internalChat"
        }

      })
    }


    if (getCookie["guestToken"]) {

      store.dispatch({
        type: meetActionTypes.CUSTOMER_CONTROL_OPEN,
        payload: {
          customerComponentState: ""
        }

      })
    }


  }

  const urlify = (text: any) => {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return text?.replace(urlRegex, function (url: any, b: any, c: any) {
      var url2 = (c === 'www.') ? 'http://' + url : url;
      return '<a target="_blank" href="' + url2 + ' ">' + url + '</a>';
    })
  }

  useEffect(() => {
    gotoBottom("chatWindow");
  }, [message]);

  const { isEmoji } = meetInfo;

  const downloadAttachment = (fileInfo: any) => {
    let filePath = fileInfo.geturl;
    let fileName = fileInfo.filename || "unknown File";
    var xhr = new XMLHttpRequest();
    xhr.open("GET", filePath, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    };
    notification.info({
      message: `File downloaded successfully`,
      placement: "topRight",
      className: "toastNotification success",
      icon: <span className="icon__Success24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,
    });
    xhr.send();
};  
let index: any = message?.length
let element: any = document.getElementById("original" + (index - 1));
useLayoutEffect(() => {
  if (element != null) {
    element.scrollTop = element?.scrollHeight - element?.clientHeight;
    element.scrollIntoView({ behavior: 'smooth', block: 'end' });
    element.scrollTo(0,element.scrollHeight);
  }

}, [element?.scrollHeight,  element?.clientHeight,element?.scrollTop ])

  return (
    <>

      <div className="chatwidgetcustomer">
        <div className="chatwidgettop">
          <h3>Chat
            <div onClick={chatWindow}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
              <path d="M9.20122 7.54398L15.0562 1.68848C15.3882 1.35738 15.3882 0.818381 15.0562 0.487281C14.7242 0.155281 14.1851 0.155281 13.855 0.487281L8.00002 6.34268L2.14502 0.487281C1.81492 0.155281 1.27392 0.155281 0.943824 0.487281C0.611824 0.818381 0.611824 1.35738 0.943824 1.68848L6.79882 7.54398L0.943824 13.3995C0.611824 13.7306 0.611824 14.2696 0.943824 14.6007C1.10982 14.7667 1.32662 14.8497 1.54442 14.8497C1.76222 14.8497 1.97992 14.7667 2.14502 14.6007L8.00002 8.74528L13.855 14.6007C14.02 14.7667 14.2378 14.8497 14.4556 14.8497C14.6734 14.8497 14.8902 14.7667 15.0562 14.6007C15.3882 14.2696 15.3882 13.7306 15.0562 13.3995L9.20122 7.54398Z" fill="#757676" />
            </svg></div></h3>
        </div>

        <div className="chatwidgetmiddle scroller"  id={"original" + index }>
          {Array.isArray(message) && message.map((elem: any, index: any) => {
            let messagebody: any = {};
            if (elem.type === 'FILE') {
              messagebody = JSON.parse(elem.body);
            }
            return (
              <div className="chatwidgetmiddleinner" key={index} id={"original" + index }>

                {elem?.from_deviceId === currdeviceinfo?.deviceid ?
                  <div className="rightchat">
                    <div className="msgtop">
                      <h3><span>{elem?.fromName?.toUpperCase().slice(0, 2)}</span>{currdeviceinfo.deviceid === elem.from_deviceId ? "You" : elem?.fromName}</h3>
                    </div>
                    { !imageFormatType.includes(messagebody.mimetype) ?  <> <div className="msgcontent">
                      {elem.type === 'TEXT' && (!elem.body.includes("https") && !elem.body.includes("http") && !elem.body.includes("www")) && <p>{elem?.body}</p>}
                      {elem.type === 'TEXT' && (elem.body.includes("https") || elem.body.includes("http") || elem.body.includes("www")) &&
                        <p className="textmsg" tabIndex={0} dangerouslySetInnerHTML={{ __html: urlify(elem.body) }}></p>}
                     { elem.type !== 'FILE' && <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>}
                   
                    {elem.type !== 'TEXT' &&<div className="forimagefiles">
           
                        {elem.type === 'FILE' && imageFormatType.includes(messagebody.mimetype) ? <img src={messagebody.geturl} alt="" /> :
                      elem.type === 'FILE' && excelMimeFormats.includes(messagebody.mimetype) ? <img src={iconxls} alt="filename" /> :
                      elem.type === 'FILE' && wordMimeFormats.includes(messagebody?.mimetype) ? <img src={iconword} alt="filename" /> :
                      elem.type === 'FILE' && pdfFormats.includes(messagebody?.mimetype) ? <img src={iconpdf} alt="filename" /> :
                      elem.type === 'FILE' && mp3Formats.includes(messagebody?.mimetype) ?<img src={iconmusic} alt="filename" /> :
                      elem.type === 'FILE' && pptMimeFormats.includes(messagebody?.mimetype) ? <img src={iconppt} alt="filename" />:
                      elem.type === 'FILE' && zipMimeFormats.includes(messagebody?.mimetype) ? <img src={iconzip} alt="filename" /> : elem.type !== 'TEXT' && <img src={iconword} alt="filename" />}
                       {elem.type === 'FILE' &&
                          <>
                            {messagebody.filename && messagebody.filename.length > 21
                              ? messagebody.filename.substring(0, 21) + "..."
                              : messagebody.filename}

                          </>}
                        <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>
                      </div>}  </div> </>
                   : <div className="msgcontent forimages">
                    {elem.type === 'FILE' && imageFormatType.includes(messagebody.mimetype) && <img src={messagebody.geturl} alt="" />}
                        <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>
                    </div>}

                  </div>
                  :
                  <div className="leftchat">
                    <div className="msgtop">
                      <h3><span>{currdeviceinfo.deviceid === elem.to_deviceId ? elem?.fromName?.toUpperCase().slice(0, 2) : elem?.toName?.toUpperCase().slice(0, 2)}</span>{currdeviceinfo.deviceid === elem.to_deviceId ? elem?.fromName : "You"}</h3>
                    </div>
                    { !imageFormatType.includes(messagebody.mimetype) ?  <> <div className="msgcontent">
                      {elem.type === 'TEXT' && (!elem.body.includes("https") && !elem.body.includes("http") && !elem.body.includes("www")) && <p>{elem?.body}</p>}
                      {elem.type === 'TEXT' && (elem.body.includes("https") || elem.body.includes("http") || elem.body.includes("www")) &&
                        <p className="textmsg" tabIndex={0} dangerouslySetInnerHTML={{ __html: urlify(elem.body) }}></p>}
                     { elem.type !== 'FILE' && <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>}
                   
                    {elem.type !== 'TEXT' &&<div className="forimagefiles" onClick={()=>downloadAttachment(messagebody)}>
           
                        {elem.type === 'FILE' && imageFormatType.includes(messagebody.mimetype) ? <img src={messagebody.geturl} alt="" /> :
                      elem.type === 'FILE' && excelMimeFormats.includes(messagebody.mimetype) ? <img src={iconxls} alt="filename" /> :
                      elem.type === 'FILE' && wordMimeFormats.includes(messagebody?.mimetype) ? <img src={iconword} alt="filename" /> :
                      elem.type === 'FILE' && pdfFormats.includes(messagebody?.mimetype) ? <img src={iconpdf} alt="filename" /> :
                      elem.type === 'FILE' && mp3Formats.includes(messagebody?.mimetype) ?<img src={iconmusic} alt="filename" /> :
                      elem.type === 'FILE' && pptMimeFormats.includes(messagebody?.mimetype) ? <img src={iconppt} alt="filename" /> :
                      elem.type === 'FILE' && zipMimeFormats.includes(messagebody?.mimetype) ? <img src={iconzip} alt="filename" />: elem.type !== 'TEXT' && <img src={iconword} alt="filename" />}
                       {elem.type === 'FILE' &&
                          <>
                            {messagebody.filename && messagebody.filename.length > 21
                              ? messagebody.filename.substring(0, 21) + "..."
                              : messagebody.filename}

                          </>}
                        <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>
                      </div>}  </div> </>
                   : <div className="msgcontent forimages" onClick={()=>downloadAttachment(messagebody)}>
                    {elem.type === 'FILE' && imageFormatType.includes(messagebody.mimetype) && <img src={messagebody.geturl} alt="" />}
                        <p className="timers">{new Date((elem.timeStamp)).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>
                    </div>}
                  </div>
                }
              </div>
            );
          })}
        </div>

        <div className="chatwidgetbottom">
          <div className="chatwidgetbottomicon">
            <input id='attachInput' type="file" onChange={uploadFile} accept="application/msword, application/vnd.ms-excel,
        application/vnd.openxmlformats-officedocument.presentationml.presentation,
        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pptx, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"  className={styles.inputAttach} hidden />
            <div onClick={inputFileClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none" >
                <path d="M14.6167 9.19272L7.61665 15.8027C6.23665 17.1127 4.04665 17.2527 2.61665 16.0027C0.976655 14.5627 0.956655 12.0727 2.50666 10.6127L10.6867 2.89272C11.5567 2.07272 12.9267 1.95272 13.8267 2.73272C14.8667 3.63272 14.8767 5.19272 13.9067 6.11272L6.95666 12.6727C6.59665 13.0127 6.01665 13.0027 5.66666 12.6327C5.31666 12.2627 5.33666 11.6927 5.70666 11.3427L11.4967 5.88272C11.7667 5.62272 11.7767 5.19272 11.5267 4.92272C11.2767 4.65272 10.8367 4.64272 10.5667 4.89272L4.86665 10.2727C3.99665 11.0927 3.79665 12.4527 4.52665 13.3927C5.36665 14.4827 6.92666 14.5827 7.89666 13.6627L14.7367 7.21272C16.1167 5.90272 16.3967 3.73272 15.2267 2.23272C13.8967 0.512724 11.3967 0.352724 9.84666 1.81272L1.72666 9.47272C-0.173345 11.2627 -0.563345 14.2627 1.04666 16.3227C2.90666 18.6827 6.31666 18.9127 8.44666 16.9027L15.5567 10.1927C15.8267 9.93272 15.8367 9.50272 15.5867 9.23272C15.3367 8.96272 14.8967 8.95272 14.6267 9.20272L14.6167 9.19272Z" fill="#757676" />
              </svg>
            </div>
            <div onClick={emojiClick}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" >
                <path d="M10 2.04297C14.6869 2.04297 18.5 5.85597 18.5 10.543C18.5 15.23 14.6869 19.043 10 19.043C5.3131 19.043 1.5 15.23 1.5 10.543C1.5 5.85597 5.3132 2.04297 10 2.04297ZM10 0.542969C4.4772 0.542969 0 5.01997 0 10.543C0 16.066 4.4772 20.543 10 20.543C15.5228 20.543 20 16.0659 20 10.543C20 5.02007 15.523 0.542969 10 0.542969Z" fill="#757676" />
                <path d="M12.6758 8.80286C13.3394 8.80286 13.8774 8.26488 13.8774 7.60126C13.8774 6.93763 13.3394 6.39966 12.6758 6.39966C12.0122 6.39966 11.4742 6.93763 11.4742 7.60126C11.4742 8.26488 12.0122 8.80286 12.6758 8.80286Z" fill="#757676" />
                <path d="M7.32416 8.80274C7.98786 8.80274 8.52586 8.26484 8.52586 7.60114C8.52586 6.93744 7.98786 6.39954 7.32416 6.39954C6.66046 6.39954 6.12266 6.93764 6.12266 7.60114C6.12266 8.26464 6.66056 8.80274 7.32416 8.80274Z" fill="#757676" />
                <path d="M13.1247 12.6738C12.3762 13.5592 11.2502 14.1191 10.0002 14.1191C8.7502 14.1191 7.624 13.5593 6.8756 12.6736C6.6497 12.4064 6.25 12.3728 5.9828 12.5985C5.7156 12.8243 5.682 13.2241 5.9078 13.4914C6.8889 14.6538 8.3674 15.3858 10.0001 15.3858C11.6328 15.3858 13.1111 14.6536 14.0923 13.4912C14.318 13.224 14.2843 12.8243 14.0171 12.5986C13.7499 12.3728 13.3503 12.4065 13.1247 12.6738Z" fill="#757676" />
              </svg>
            </div>
            <div className="bottommessage" onClick={sendMessage}>
              <textarea name="" placeholder="Send a message " onChange={(e: any) => onUpdateMessage('messageText', e)} onKeyPress={handleKeyPress} value={meetInfo.messageText}></textarea>
             { meetInfo.messageText.length === 0 ? <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
                <path d="M19.5814 0.528522C19.1791 0.120322 18.5726 -0.0134778 18.035 0.182822L1.00426 6.34782C0.457363 6.53632 0.0799628 7.00992 0.0188628 7.58322C-0.0412372 8.14572 0.217063 8.67502 0.677063 8.95332L3.72196 10.9191C4.08816 11.1515 4.56376 11.1584 4.93386 10.9318L15.2732 4.15922L5.59306 11.8546C5.39236 12.0265 5.25716 12.2648 5.21216 12.5226L4.76586 15.0499C4.65406 15.6827 4.92996 16.2901 5.46946 16.5987C6.00656 16.9053 6.65986 16.8438 7.13496 16.4366L9.35766 14.5304L12.7713 16.7618C13.0071 16.9161 13.284 16.9952 13.5638 16.9952C13.7318 16.9952 13.9012 16.9669 14.0633 16.9083C14.4979 16.7511 14.825 16.4093 14.9525 15.9952L19.89 2.03522C20.0956 1.50882 19.9774 0.930822 19.5814 0.528522Z" fill="#E3E4E5" />
              </svg>
              :
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_3354_79351)">
              <path d="M21.5809 3.98403C21.1786 3.57583 20.5721 3.44203 20.0345 3.63833L3.00377 9.80333C2.45687 9.99183 2.07947 10.4654 2.01837 11.0387C1.95827 11.6012 2.21657 12.1305 2.67657 12.4088L5.72147 14.3746C6.08767 14.607 6.56327 14.6139 6.93337 14.3873L17.2727 7.61473L7.59257 15.3101C7.39187 15.482 7.25667 15.7203 7.21167 15.9781L6.76537 18.5054C6.65357 19.1382 6.92947 19.7456 7.46897 20.0542C8.00607 20.3608 8.65937 20.2993 9.13447 19.8921L11.3572 17.9859L14.7708 20.2173C15.0066 20.3716 15.2835 20.4507 15.5633 20.4507C15.7313 20.4507 15.9007 20.4224 16.0628 20.3638C16.4974 20.2066 16.8245 19.8648 16.952 19.4507L21.8895 5.49073C22.0951 4.96433 21.9769 4.38633 21.5809 3.98403Z" fill="#000"/>
             </g>
             <defs>
             <clipPath id="clip0_3354_79351">
             <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
             </svg> }

            </div>
          </div>
        </div>

        {isEmoji && <div className={styles.emojis}>
          <URemojiMessage handleEmoji={onEmojiClick} ></URemojiMessage>
        </div>}
      </div>

    </>
  )
}



